import { PayloadAction } from '@reduxjs/toolkit';
import createAppSlice from 'app/createAppSlice';
import type { IMarketingSlice } from './types';

const initialState: IMarketingSlice = {
  params: null,
  employeeId: null,
  freeSpiritNumber: null,
  coBrand: null,
  isEmbeddedInMobileApp: false,
};

const marketingSlice = createAppSlice({
  name: 'marketing',
  initialState,
  reducers: {
    /**
     * Written once, from the landing URL. Replaces the whole slice rather than merging so a
     * later in-app navigation — which no longer carries the params — cannot half-clear it.
     */
    setMarketingAttribution: (
      state,
      action: PayloadAction<IMarketingSlice>,
    ) => {
      return action.payload;
    },
    resetMarketing: () => {
      return initialState;
    },
  },
});

export const { setMarketingAttribution, resetMarketing } =
  marketingSlice.actions;
export default marketingSlice.reducer;
